// Lordicon Lazy Loading
(function() {
  'use strict';

  // Check if Lordicon is already loaded
  window.lordiconLoaded = false;

  // Function to load Lordicon script
  window.loadLordicon = function() {
    if (window.lordiconLoaded) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.lordicon.com/lordicon.js';
      script.async = true;
      script.onload = function() {
        window.lordiconLoaded = true;
        // Mark all Lordicon elements as loaded
        document.querySelectorAll('lord-icon.lordicon-lazy').forEach(function(element) {
          element.setAttribute('data-loaded', 'true');
        });
        // Trigger any pending Lordicon elements to load
        document.dispatchEvent(new CustomEvent('lordicon:loaded'));
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  // Initialize lazy loading for existing Lordicon elements
  function initLordiconLazyLoading() {
    const lordiconElements = document.querySelectorAll('lord-icon.lordicon-lazy');

    if (lordiconElements.length === 0) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Load Lordicon script when element becomes visible
          window.loadLordicon().then(() => {
            // The script will automatically handle the Lordicon elements
          }).catch(console.error);

          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px' // Start loading 50px before element comes into view
    });

    lordiconElements.forEach(function(element) {
      observer.observe(element);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLordiconLazyLoading);
  } else {
    initLordiconLazyLoading();
  }

  // Re-initialize for dynamically loaded content (Shopify sections)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initLordiconLazyLoading, 100);
  });

})();